import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ number, eyebrow, title, text, light = false }) => (
  <Reveal className="mb-12 md:mb-16 max-w-3xl">
    <p className={`eyebrow mb-4 ${light ? "!text-[#9DBFA9]" : ""}`} data-testid={`section-eyebrow-${number}`}>
      {number} — {eyebrow}
    </p>
    <h2
      className={`font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight ${
        light ? "text-[#F8F7F2]" : "text-[#1A382B]"
      }`}
    >
      {title}
    </h2>
    {text && (
      <p className={`mt-5 text-base sm:text-lg leading-relaxed ${light ? "text-[#C4D2C8]" : "text-[#47544A]"}`}>
        {text}
      </p>
    )}
  </Reveal>
);
